export interface INewApiUserRole {
  PapelNo: number;
  PapelNome: string;
  BlAdm: boolean;
  DepartamentoNo: number;
}
